import React, { useEffect,  useState } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import { loadPopupMessage, savePopupMessage } from '../utils/Network';
import Gallery from './Gallery';
import SelectLanguage from '../components/SelectLanguage';
import { useParams } from 'react-router-dom';
export default function PopupMessage() {

    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);
    const [url, setUrl] = useState(null);
    const [description, setDescription] = useState(null);
    const [error, setError] = useState(null);
    const [gallery_modal_is_open, setGalleryModalIsOpen] = useState(false);
    const [gallery_item, setGalleryItem] = useState(false);
    const [language_id, setLanguageId] = useState(false);
    const [image, setImage] = useState(false);
    
    const params = useParams()
    
    useEffect(() => {
        if (params.id) {
            loadPopupMessage(params.id).then(vg => {
                setDescription(vg.description)
                setLanguageId(vg.language)
                setImage(vg.image)
                setUrl(vg.url)
            })
        }
    }, []);


    const onChange = (e) => {
        //alert(e.target.name)
        switch (e.target.name) {
            case 'description':
                setDescription(e.target.value)
                break;
            case 'url':
                setUrl(e.target.value)
                break;
            default:
                break;
        }
    }
   
    

    const SaveChanges = () => {

        setError(false)
      
        if (!language_id) {
            setError("Please select Language")
            return;
        }
        
        setLoading(true)
        savePopupMessage(params.id,url, description,language_id,gallery_item ? gallery_item.image : image)
        .then(res => {
            if (res.id){
                setDone("Changes saved successfully");
            }
            setLoading(false)
        })
    }

    
    const openGallery = () => {
        setGalleryModalIsOpen(true)
    }
    const closeGallery = () => {
        setGalleryModalIsOpen(false)
    }

    const setSelectedImageGallery = (gallery_item) => {
        setGalleryItem(gallery_item)
    }

    const handleValue = (value, name) => {
        switch (name) {
            case "language":
                setLanguageId(value)
                break;
                
            default:
                break;
        }
    }
  

    return (
        <div class="wrapper">
            <Navbar />
            <Mainmenu />
            <Gallery setSelectedGalleryItem={setSelectedImageGallery} isOpen={gallery_modal_is_open} key={gallery_modal_is_open} closeGallery={() => { closeGallery()}} />

                <div className="content-wrapper">
                    <section className="content-header">
                        <h3 className="box-title mb-10"></h3>
                        <ol className="breadcrumb">
                            <li><a href="/cms"><i className="fa fa-dashboard"></i> Home</a></li>
                            <li className="active">Popup message item</li>
                        </ol>
                    </section>
                    <section className="content">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="box ">
                                    <div className="box-header">
                                        Details
                                    </div>
                                    <div className="box-body padding-10 bg-ddd">
                                        <div className="form-group">
                                            <input type="text" value={url} name="url" onChange={onChange} className="form-control" placeholder="Url" />
                                        </div>
                                    </div>
                                    <div className="box-body padding-10 bg-ddd">
                                        <div className="form-group">
                                            <input type="text" value={description} name="description" onChange={onChange} className="form-control" placeholder="Description" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="box bg-ddd">
                                    <div className="box-header">
                                        Information
                                    </div>
                                    <div className="box-body padding-10">
                                        
                                        <div className="form-group">
                                            <SelectLanguage width={250} callback={handleValue} value={language_id} border={"1"} />
                                        </div>
                                        <div className="form-group ">
                                            <img className="img upload-img mb-5" onClick={openGallery} src={gallery_item ? gallery_item.image : image ? image : "images/default.png"} />
                                        </div>
                                    
                                    </div>
                                    
                                    <div className="box-footer">
                                        <button className="btn btn-primary pull-right" onClick={SaveChanges}>Save Changes</button>
                                        <a href={`popupmessages`} className="btn btn-default pull-left">Cancel</a>
                                    </div>
                                    {error &&
                                        <div className="alert alert-danger mt-5">
                                            {error}
                                        </div>
                                    }
                                    {loading &&
                                        <div className="alert alert-info  mt-5">
                                            Please Wait...
                                        </div>
                                    }
                                    {done &&
                                        <div className="alert alert-success  mt-5">
                                            {done}
                                        </div>
                                    }
                                </div>

                            </div>
                        </div>
                    </section>

                    
                </div>
            <Footer />

        </div>
            

    )
}
